import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import '../style/Signup.css';
import eventsAPI from "../api/eventsAPI";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Handles the form submission for user registration.
//  Sends a POST request to the server with the form data.
//  If the user is found, shows a success toast and navigates to the login page.
//  If the user is not found, shows a success toast and navigates to the signup page.
//  If an error occurs, shows an error message.
const Register = () => {
  const { user, setUser } = useAuth();
  // const [data, setData] = useState(user);
  const [error, setError] = useState("");

  const { emailID } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const response = await eventsAPI.post("/login/register", {
        ...user,
        id: emailID,
      });

      if (response.data.found) {
        toast.success("Registration successful");
        setUser((prev) => ({ ...prev, completed: 10 }));
        // setUser(data);
        navigate("/login");
      } else {
        toast.success("User account not found");
        navigate("/signup");
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className="signup-page">
      <div className="heading-section">
        <h1>REGISTER PAGE</h1>
      </div>
      <main className="main">
        <div className="left-side"></div>
        <div className="right-side">
          <form onSubmit={handleSubmit}>
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              placeholder="Enter First Name"
              name="firstName"
              value={user?.firstName}
              onChange={(e) =>
                setUser((prev) => ({ ...prev, firstName: e.target.value }))
              }
              //required
            />
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              placeholder="Enter Last Name"
              name="lastName"
              value={user?.lastName}
              onChange={(e) =>
                setUser((prev) => ({ ...prev, lastName: e.target.value }))
              }
              //required
            />
            <label htmlFor="age">Age</label>
            <input
              type="number"
              placeholder="Enter Age"
              name="age"
              value={user?.age}
              onChange={(e) =>
                setUser((prev) => ({ ...prev, age: e.target.value }))
              }
              //required
            />
            <label htmlFor="gender">Gender</label>
            <select
              name="gender"
              value={user?.gender}
              onChange={(e) =>
                setUser((prev) => ({ ...prev, gender: e.target.value }))
              }
              //required
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="register-btn">
              Register
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Register;
